;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import SvgIcon from "@mui/material/SvgIcon"
import svg from "../assets/dashedLineMobile.svg"

function MobileDashedLineIcon() {
  return (
    <SvgIcon
      component={svg}
      viewBox="0 0 520 1"
      sx={{
        width: "520px",
        height: "1px",
        maxWidth: "100%",
      }}
    />
  )
}
export default MobileDashedLineIcon
